export default "__VITE_ASSET__LjE$izdIupfB7Ou_wxx1WQ__"